// What a new board of each kind is called and the look it starts in, for every way one is made: the New board
// dialog's cards and voice ("new doc board").

import { BOARD_KINDS } from "../../shared/boardKinds";
import type { BoardKind, ThemeSettings } from "../../shared/types";

/**
 * What a new board of each kind is called, and the look it starts in: a doc reads best on paper. Named by what it is,
 * "Doc", "Sheet", "Deck", the next of a kind "Doc 2" (Fixes 12: seven kinds started "New ..."); a canvas stays New board.
 * A plan's and a map's names are looked for while they are unchanged (isNewPlan in shared/plan.ts, isNewMap in mindmap/ideas.ts).
 */
const START: Partial<Record<BoardKind, { name: string; theme: ThemeSettings }>> = {
  canvas: { name: "New board", theme: { id: "studio" } },
  doc: { name: "Doc", theme: { id: "paper" } },
  slides: { name: "Deck", theme: { id: "paper" } },
  plan: { name: "Plan", theme: { id: "paper" } },
  mindmap: { name: "Mind map", theme: { id: "space" } },
  calendar: { name: "Content calendar", theme: { id: "daydream" } },
  agenda: { name: "Calendar", theme: { id: "summit" } },
  pipeline: { name: "Clients", theme: { id: "studio" } },
  sheet: { name: "Sheet", theme: { id: "paper" } },
  custom: { name: "Tool", theme: { id: "studio" } },
};

export function startOf(kind: BoardKind): { name: string; theme: ThemeSettings } {
  return START[kind] ?? { name: BOARD_KINDS[kind].name, theme: { id: "studio" } };
}
